import "./OurExpertise.module.css";
import MainNavigation from "@/reusable_sections/Header";
import PowerSolutionsOverview from "./sections/PowerSolutionsOverview";
import ResidentialCommercial from "./sections/ResidentialCommercial";
import FooterInformation from "@/reusable_sections/Footer";
export default function OurExpertisePage() {
  return <div>
      <MainNavigation />
      <PowerSolutionsOverview />
      <ResidentialCommercial />
      <FooterInformation />
    </div>;
}